import type { PortableTextTypeComponentProps } from '@portabletext/react';
import useDataAttribute from '../infrastructure/DataAttributeContext';
import type { Keyed } from '../types';

export function Phrase({ value }: PortableTextTypeComponentProps<Keyed<{ text: string }>>) {
    const attr = useDataAttribute();
    return <span data-sanity={attr?.([{ _key: value._key }])}>{value?.text}</span>;
}
